import { schema } from 'normalizr';

export const plansSchema = new schema.Entity(
  'plans',
  {},
  {
    idAttribute: 'name',
  },
);

export const promotionsSchema = new schema.Entity(
  'promotions',
  {},
  {
    idAttribute: 'id',
  },
);
